import api from 'api'
import { AcompanhamentoCondicaoSaudeQueryInput } from 'graphql/types.generated'
import { defaultHandleError } from 'util/downloadFile'

export const downloadAcompanhamentoCondicaoSaudeCSV = (input: AcompanhamentoCondicaoSaudeQueryInput) => {
  return api.acompanhamentoSaude.exportarCSV(input).catch(defaultHandleError)
}

export const downloadAcompanhamentoCondicaoSaudePDF = (input: AcompanhamentoCondicaoSaudeQueryInput) => {
  return api.acompanhamentoSaude.exportarPDF(input).catch(defaultHandleError)
}
